module.exports = __webpack_public_path__ + "static/media/NightOwl.dfbc9632.svg";